import React from "react";
import logo from './HeaderImg/econirmit_logo.png';
import footerBg from './HeaderImg/footer png.png';
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className="text-gray-800 px-6 py-10 border-t border-gray-200"
      style={{
        backgroundImage: `url(${footerBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Logo */}
        <div className="mb-8">
          <img src={logo} alt="Econirmit Logo" className="h-12 md:h-14" />
        </div>

        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h2 className="font-semibold text-lg md:text-xl mb-4">Company</h2>
            <p className="text-gray-700 text-base md:text-lg">
              Manufactured & Marketed By: <br />
              PUSHPANJALI ECONIRMIT, <br />
              12/16, Pragati Nagar, Nanakheda, <br />
              UJJAIN (M.P.)
            </p>
            <p className="mt-2 text-base md:text-lg">+91 8827373432</p>
            <p className="text-base md:text-lg">Mail: contact@econirmit.com</p>
          </div>

          {/* Information */}
          <div>
            <h2 className="font-semibold text-lg md:text-xl mb-4">Information</h2>
            <ul className="space-y-2 text-gray-700 text-base md:text-lg">
              <li><Link to="/ContactPage"> Bulk, Orders </Link></li>
              <li > <Link to="/ContactPage">Contact</Link></li>
            </ul>
          </div>

          {/* Get Help */}
          <div>
            <h2 className="font-semibold text-lg md:text-xl mb-4">Get Help</h2>
            <ul className="space-y-2 text-gray-700 text-base md:text-lg">
              <li><Link to='/privaciy-policy'> Privacy & Policy </Link></li>
              <li><Link to="/returns-policy">Return Policy</Link> </li>
              <li><Link to="/shipping-policy">Shipping Policy</Link></li>
              <li> <Link to="/terms-condition">Terms & Conditions</Link> </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-300 my-6"></div>

        {/* Copyright */}
        <div className="text-center text-gray-600 text-sm md:text-base">
           Copyright ©2025 by Pushpanjali Econirmit. All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
